export const auth = {
errors: {
  deleteAccountFailed: "لم يُحذف حسابك. حاول مرة أخرى.",
  workspacePreparing: "ما زالت مساحة عملك قيد الإعداد. انتظر لحظة، ثم حاول مرة أخرى.",
  signInAgain: "سجّل الدخول مرة أخرى للمتابعة.",
  callbackCancelled: "أُلغي تسجيل الدخول قبل اكتماله. حاول مرة أخرى عندما تكون جاهزًا.",
  signInNotFinished: "لم يكتمل تسجيل الدخول. حاول مرة أخرى.",
  signupUnavailable: "لا يمكننا إنشاء حسابات الآن. حاول لاحقًا.",
  signupClosed: "الحسابات الجديدة بالدعوة فقط حاليًا. استخدم الرابط في رسالة الدعوة، أو سجّل الدخول بحسابك الحالي.",
  linkExpired: "انتهت صلاحية هذا الرابط أو استُخدم من قبل. اطلب رابطًا جديدًا.",
  emailInvalid: "أدخل عنوان بريد إلكتروني صالحًا.",
  passwordTooCommon: "كلمة المرور هذه سهلة التخمين. اختر كلمة أخرى.",
  passwordNeedsMix: "استخدم أحرفًا كبيرة وصغيرة وأرقامًا ورموزًا.",
  passwordTooShort: "استخدم {{n}} أحرف على الأقل.",
  samePassword: "اختر كلمة مرور لم تستخدمها من قبل.",
  emailRateLimited: "أرسلنا إليك رسالة للتو. انتظر دقيقة قبل طلب رسالة أخرى.",
  rateLimited: "محاولات كثيرة. انتظر دقيقة، ثم حاول مرة أخرى.",
  alreadyRegistered: "لهذا البريد حساب بالفعل. اضغط تسجيل الدخول، أو نسيت كلمة المرور؟ إذا احتجت إلى كلمة مرور جديدة.",
  emailNotConfirmed: "أكّد بريدك الإلكتروني أولًا. افتح الرابط الذي أرسلناه إليك، ثم سجّل الدخول.",
  invalidCredentials: "البريد الإلكتروني وكلمة المرور غير متطابقين. تحقّق منهما، ثم حاول مرة أخرى.",
  offline: "أنت غير متصل. تحقّق من اتصالك، ثم حاول مرة أخرى.",
  generic: "حدث خطأ ما. حاول مرة أخرى.",
},
session: {
  signIn: "تسجيل الدخول",
  renew: "تجديد الجلسة",
  expiredBody: "اضغط تجديد الجلسة لمتابعة العمل، أو تسجيل الدخول للبدء من جديد.",
  expiredTitle: "انتهت جلستك",
},
appName: "AssetWRX",
social: {
  errorStartFailed: "لم يبدأ تسجيل الدخول. حاول مرة أخرى.",
  errorPopupTimeout: "انتظرت نافذة تسجيل الدخول طويلًا وأُغلقت. اضغط زر تسجيل الدخول للبدء من جديد.",
  errorPopupBlocked: "حظر متصفحك نافذة تسجيل الدخول. اسمح بالنوافذ المنبثقة لهذه الصفحة، ثم اضغط زر تسجيل الدخول مرة أخرى.",
continueWith: "أو تابع باستخدام",
google: "متابعة باستخدام Google",
apple: "متابعة باستخدام Apple",
microsoft: "متابعة باستخدام Microsoft",
signingIn: "جارٍ فتح تسجيل الدخول...",
errorSignInFailed: "لم يكتمل تسجيل الدخول. حاول مرة أخرى.",
},
callback: {
  continueHere: "المتابعة في هذا المتصفح",
  appSignInHint: "في التطبيق، اضغط تسجيل الدخول واستخدم البريد الإلكتروني وكلمة المرور اللذين اخترتهما للتو.",
title: "جارٍ تسجيل دخولك",
body: "لحظة من فضلك.",
successTitle: "تم تسجيل دخولك",
successBody: "جارٍ فتح AssetWRX…",
errorTitle: "لم يكتمل تسجيل الدخول",
error: "انتهت صلاحية هذا الرابط أو استُخدم من قبل. اضغط العودة إلى تسجيل الدخول وحاول مرة أخرى.",
backToSignIn: "العودة إلى تسجيل الدخول",
openInApp: "افتح تطبيق AssetWRX",
},
login: {
  biometricPasswordChanged: "تغيّرت كلمة المرور، لذا أُوقف {{method}}. سجّل الدخول بكلمة المرور الجديدة وحدّد استخدام {{method}} في المرة القادمة.",
  title: "سجّل الدخول إلى AssetWRX",
showPassword: "إظهار كلمة المرور",
hidePassword: "إخفاء كلمة المرور",
subtitle: "سجّل الدخول إلى حسابك",
email: "البريد الإلكتروني",
password: "كلمة المرور",
emailPlaceholder: "you@example.com",
passwordPlaceholder: "كلمة المرور",
forgotPassword: "نسيت كلمة المرور؟",
signIn: "تسجيل الدخول",
signingIn: "جارٍ تسجيل الدخول...",
noAccount: "ليس لديك حساب؟",
createAccount: "إنشاء حساب",
createAccountCta: "مستخدم جديد؟ أنشئ حسابًا",
orWithEmail: "أو سجّل الدخول بالبريد الإلكتروني",
newHere: "جديد في AssetWRX؟",
createAccountLink: "إنشاء حساب",
biometricUseNextTime: "استخدام {{method}} في المرة القادمة",
biometricSignIn: "تسجيل الدخول باستخدام {{method}}",
biometricPrompt: "تسجيل الدخول إلى AssetWRX",
biometricMethodFace: "Face ID",
biometricMethodFingerprint: "بصمة الإصبع",
biometricMethodIris: "قزحية العين",
biometricMethodGeneric: "المقاييس الحيوية",
embedSsoHint: "تسجّلك هذه البوابة الدخول بحساب Microsoft الخاص بمؤسستك.",
errorEmailRequired: "يرجى إدخال بريدك الإلكتروني.",
errorEmailInvalid: "أدخل عنوان بريد إلكتروني صالحًا.",
errorPasswordRequired: "يرجى إدخال كلمة المرور.",
errorLoginFailed: "لم ينجح تسجيل الدخول. تحقّق من بريدك الإلكتروني وكلمة المرور، ثم حاول مرة أخرى.",
},
signup: {
  passwordHint: "استخدم {{n}} أحرف على الأقل.",
  useDifferentEmail: "استخدام بريد إلكتروني آخر",
title: "إنشاء حساب",
subtitle: "انضم إلى AssetWRX — نظام التشغيل لأصولك المادية.",
firstName: "الاسم الأول",
firstNamePlaceholder: "محمد",
lastName: "اسم العائلة",
lastNamePlaceholder: "أحمد",
role: "الدور",
rolePlaceholder: "مدير العمليات",
email: "البريد الإلكتروني",
emailPlaceholder: "you@example.com",
password: "كلمة المرور",
passwordPlaceholder: "اختر كلمة مرور قوية",
showPassword: "إظهار كلمة المرور",
hidePassword: "إخفاء كلمة المرور",
confirmPassword: "تأكيد كلمة المرور",
confirmPlaceholder: "أعد إدخال كلمة المرور",
submit: "إنشاء حساب",
signingUp: "جارٍ إنشاء الحساب...",
hasAccount: "لديك حساب بالفعل؟",
signInLink: "تسجيل الدخول",
emailInstead: "التسجيل بالبريد الإلكتروني بدلاً من ذلك",
emailInsteadHide: "إخفاء التسجيل بالبريد الإلكتروني",
useEmail: "استخدام البريد الإلكتروني بدلًا من ذلك",
useEmailHide: "إخفاء التسجيل بالبريد الإلكتروني",
name: "اسمك",
namePlaceholder: "أليكس طاهر",
errorNameRequired: "يرجى إدخال اسمك.",
hasAccountShort: "لديك حساب بالفعل؟",
errorFirstNameRequired: "يرجى إدخال الاسم الأول.",
errorLastNameRequired: "يرجى إدخال اسم العائلة.",
errorRoleRequired: "يرجى إدخال الدور.",
errorEmailRequired: "يرجى إدخال بريدك الإلكتروني.",
errorPasswordRequired: "يرجى إدخال كلمة مرور.",
errorPasswordMismatch: "كلمتا المرور غير متطابقتين.",
emailInvalid: "أدخل عنوان بريد إلكتروني صالحًا.",
passwordsMatch: "كلمتا المرور متطابقتان.",
passwordStrength: {
weak: "ضعيفة",
fair: "مقبولة",
good: "جيدة",
strong: "قوية",
},
errorSignUpFailed: "لم يُنشأ حسابك. حاول مرة أخرى.",
errorLanguageInvalid: "يرجى اختيار لغة مدعومة.",
errorTimezoneInvalid: "يرجى اختيار منطقة زمنية صالحة.",
regionalSectionTitle: "اللغة والمنطقة الزمنية والعملة",
regionalSectionBody: "تُطبَّق على ملفك الشخصي ومساحة العمل الجديدة. يمكنك تغييرها لاحقًا من الإعدادات.",
languageLabel: "اللغة",
timezoneLabel: "المنطقة الزمنية",
currencyLabel: "عملة مساحة العمل",
currencyA11y: "عملة مساحة العمل {{code}}",
successCheckEmail: "تم إنشاء الحساب. تحقق من بريدك لتأكيد الحساب ثم سجّل الدخول.",
successEmailTitle: "افحص بريدك الوارد",
successEmailBody: "أرسلنا رابطًا إلى {{email}}. افتحه لإكمال إنشاء حسابك.",
resendConfirmation: "إرسال الرابط مرة أخرى",
resendingConfirmation: "جارٍ الإرسال…",
resendSuccess: "تم الإرسال. افحص بريدك الوارد ومجلد الرسائل غير المرغوب فيها.",
resendError: "لم يُرسَل الرابط. انتظر دقيقة، ثم اضغط إرسال الرابط مرة أخرى.",
consent: {
sectionTitle: "قبل أن تستمر",
sectionBody: "يرجى مراجعة المستندات أدناه والموافقة عليها. كلاهما مطلوب لإنشاء حسابك.",
acceptTerms: "لقد قرأت وأوافق على <1>شروط الخدمة</1>.",
acceptPrivacy: "لقد قرأت وأوافق على <1>سياسة الخصوصية</1>.",
errorTermsRequired: "يرجى الموافقة على شروط الخدمة للاستمرار.",
errorPrivacyRequired: "يرجى الموافقة على سياسة الخصوصية للاستمرار.",
a11yTermsCheckbox: "الموافقة على شروط الخدمة",
a11yPrivacyCheckbox: "الموافقة على سياسة الخصوصية",
compactLead: "أوافق على:",
termsShort: "الشروط",
read: "اقرأ",
privacyShort: "الخصوصية",
a11yReadTerms: "اقرأ شروط الخدمة",
a11yReadPrivacy: "اقرأ سياسة الخصوصية",
shareUsage: "مشاركة بيانات الاستخدام للمساعدة في تحسين AssetWRX (اختياري)",
byContinuingBefore: "بالمتابعة فإنك توافق على ",
byContinuingBetween: " و",
byContinuingAfter: ".",
termsDoc: "شروط الخدمة",
privacyDoc: "سياسة الخصوصية",
},
wizard: {
flowSubtitle: "إعداد سريع وموجّه لمساحة عملك",
valueStrip: "ابدأ مجانًا. لا حاجة لبطاقة.",
stepProgress: "الخطوة {{current}} من {{total}}",
loadingDraft: "جارٍ استعادة تقدّمك…",
welcomeBody: "أنشئ حسابك باستخدام Google أو Apple أو Microsoft أو البريد الإلكتروني. تمر الحسابات الجديدة بإعداد قصير بعد تسجيل الدخول.",
continueWithEmail: "متابعة باستخدام البريد الإلكتروني",
back: "رجوع",
next: "التالي",
yes: "نعم",
no: "لا",
errorUseCaseRequired: "يرجى اختيار الطريقة التي تخطط لاستخدام AssetWRX بها.",
errorWorkspaceNameRequired: "يرجى إدخال اسم مساحة العمل.",
errorStarterRequired: "اختر ما تريد القيام به أولًا.",
useCaseTitle: "حالة الاستخدام الأساسية",
useCaseBody: "اختر الخيار الذي يصفك بأفضل شكل. يمكنك تعديل هذا لاحقًا.",
useCases: {
field_inspections: "فحص الأماكن أو المعدات",
asset_register: "الاحتفاظ بسجل لما نتولى رعايته",
jobs_workorders: "تنظيم الإصلاحات والأعمال",
team_collab: "العمل مع فريقي",
compliance_reporting: "الشهادات والامتثال",
other: "شيء آخر",
},
workspaceTitle: "مساحة عملك",
workspaceBody: "هذه هي مساحة مؤسستك في AssetWRX. يمكنك إعادة تسميتها لاحقًا من الإعدادات.",
workspaceNameLabel: "اسم مساحة العمل",
workspaceNamePlaceholder: "مثال: Acme Facilities",
inviteOnlyNote: "الانضمام إلى فريق شخص آخر يتم بالدعوة فقط (استخدم الرابط من رسالة الدعوة الإلكترونية).",
intentCreateTeam: "إنشاء فريق في مساحة العمل هذه",
intentInviteMembers: "دعوة أعضاء الفريق بعد الإعداد",
starterTitle: "ما الذي تريد القيام به أولًا؟",
starterBody: "سنفتح القسم المناسب بعد تسجيل الدخول وإنهاء الإعداد.",
starters: {
home: "فتح لوحة التحكم الرئيسية",
asset: "إضافة أصل",
inspection: "بدء تفتيش",
schedule: "جدولة تفتيش",
team: "إدارة الفريق والدعوات",
},
reviewTitle: "مراجعة وإنشاء الحساب",
reviewName: "الاسم: {{name}}",
reviewEmail: "البريد الإلكتروني: {{email}}",
reviewWorkspace: "مساحة العمل: {{name}}",
reviewTeam: "إنشاء فريق: {{yes}}",
reviewInvites: "دعوة الأعضاء: {{yes}}",
reviewEditHint: "تعرض هذه الخطوة ملخصًا فقط. لكتابة اسم أو بريد إلكتروني أو كلمة مرور مختلفة، استخدم الزر أدناه (أو اضغط رجوع للتنقل بين الصفحات السابقة).",
reviewEditCta: "تعديل الاسم والبريد الإلكتروني وكلمة المرور",
},
},
firstRunSample: {
secondCheck: {
property: "أجهزة إنذار الدخان موجودة وتعمل؟",
vehicle: "الأضواء والإطارات سليمة؟",
equipment: "الواقيات وملصقات التحذير في مكانها؟",
other: "معدات السلامة موجودة وصالحة للاستخدام؟",
},
quickLook: {
templateName: "جولة تفقّد سريعة",
firstCheck: "الحالة الظاهرة مقبولة؟",
},
useCases: {
field_inspections: {
assetName: "مضخة تدوير تجريبية",
assetDescription: "مثال يمكنك إزالته لتجربة فحص ميداني.",
templateName: "فحص حالة المضخة",
firstCheck: "الغلاف والواقيات مثبتة؟",
secondCheck: "هل يوجد تسرب أو ضجيج أو اهتزاز؟",
},
jobs_workorders: {
assetName: "وحدة مناولة هواء تجريبية",
assetDescription: "مثال يمكنك إزالته لاكتشاف أعمال الصيانة وتسليمها.",
templateName: "جولة صيانة",
firstCheck: "نقاط الوصول والعزل خالية من العوائق؟",
secondCheck: "هل تلزم صيانة لاحقة؟",
},
compliance_reporting: {
assetName: "معدات سلامة من الحريق تجريبية",
assetDescription: "مثال يمكنك إزالته لتجربة فحوصات امتثال قائمة على الأدلة.",
templateName: "فحص أدلة الامتثال",
firstCheck: "تم التحقق من التعريف والحالة؟",
secondCheck: "الأدلة موثقة وسارية؟",
},
asset_register: {
assetName: "مركبة خدمة تجريبية",
assetDescription: "مثال يمكنك إزالته يعرض سجل أصل تشغيلي.",
templateName: "فحص حالة المركبة",
firstCheck: "الحالة الخارجية مقبولة؟",
secondCheck: "معدات السلامة موجودة وصالحة للاستخدام؟",
},
other: {
assetName: "معدة تجريبية",
assetDescription: "مثال يمكنك إزالته لتجربة فحص وأعمال متابعة.",
templateName: "فحص تشغيلي سريع",
},
},
},
postSignupOnboarding: {
industryTitle: "ماذا تدير؟",
industryHint: "نضيف قوائم تحقق جاهزة. يمكنك تغييرها لاحقًا من قوائم التحقق.",
industryChoices: {
property: "العقارات",
fleet: "الأسطول",
equipment: "المعدات",
facilities: "المرافق",
mixed: "مزيج، أو شيء آخر",
},
title: "إعداد مساحة العمل",
subtitle: "اسم وخياران سريعان وستكون جاهزًا.",
stepProgress: "الخطوة {{current}} من {{total}}",
workspaceTitle: "اسم مساحة العمل",
workspacePlaceholder: "اسم مؤسستك أو فريقك",
workspaceHint: "عادةً اسم شركتك أو فريقك. يمكنك تغييره لاحقًا.",
useCaseTitle: "فيمَ ستستخدم AssetWRX؟",
roleTitle: "دورك",
teamTitle: "الفريق والدعوات",
starterTitle: "من أين تريد أن تبدأ؟",
finish: "متابعة",
finishing: "جارٍ الإعداد…",
deferNote: "يمكنك تغيير اللغة والعملة وإعدادات الفريق لاحقًا من الحساب.",
errorWorkspaceRequired: "يرجى إدخال اسم مساحة العمل.",
errorUseCaseRequired: "يرجى اختيار حالة استخدام أساسية.",
errorRoleRequired: "يرجى اختيار دورك.",
errorSave: "تعذّر الحفظ. حاول مرة أخرى.",
inviteNote: "يمكنك دعوة أشخاص بعد هذه الخطوة.",
applyingTitle: "جارٍ تطبيق اختياراتك",
applyingBody: "نجهّز مساحة عملك. لحظة من فضلك.",
languageTitle: "اللغة",
localeLineTitle: "العملة واللغة",
localeChange: "تغيير",
localeDone: "تم",
languageHint: "اختر لغتك. يمكنك تغييرها لاحقًا من الحساب.",
currencyTitle: "العملة",
currencyHint: "اختر العملة التي تعمل بها. يمكنك تغييرها لاحقًا من الحساب.",
},
firstActionChooser: {
title: "بماذا تريد أن تبدأ؟",
framing: "أضف شيئًا تتولى رعايته، أو جرّب فحصًا تدريبيًا على مثال.",
framingTeam: "ادعُ من تعمل معهم، أو أضف شيئًا تتولى رعايته، أو جرّب فحصًا تدريبيًا.",
asset: {
title: "أضف أصلي الأول",
subtitle: "يكفي اسم ونوع. أضف المزيد لاحقًا.",
},
sample: {
title: "جرّب فحصًا تدريبيًا",
subtitle: "نضيف أصلًا تجريبيًا لترى كيف يتم الفحص. يمكنك إزالته في أي وقت.",
},
recommended: "مقترح",
reassure: "يمكنك إزالة المثال في أي وقت.",
sampleErrorFallback: "تعذر تجهيز النموذج. يمكنك إضافة أصلك الخاص بدلاً من ذلك.",
skip: "الانتقال إلى الرئيسية",
team: {
title: "إعداد فريقك",
subtitle: "أنشئ فريقًا وادعُ من تعمل معهم. سنريك كل خطوة.",
subtitleLocked: "الفرق متاحة في خطة أعلى. اضغط لترى الخطط التي تتضمنها.",
},
},
forgot: {
  sentAgain: "أُعيد الإرسال. افحص بريدك الوارد ومجلد الرسائل غير المرغوب فيها.",
  spamHint: "لم يصلك؟ افحص مجلد الرسائل غير المرغوب فيها.",
  sendAgain: "إرساله مرة أخرى",
title: "نسيت كلمة المرور؟",
subtitleEmail: "أدخل بريدك الإلكتروني واضغط إرسال الرابط. سنرسل إليك رابطًا لاختيار كلمة مرور جديدة.",
email: "البريد الإلكتروني",
emailPlaceholder: "you@example.com",
sendLink: "إرسال الرابط",
sending: "جارٍ الإرسال...",
backToSignIn: "العودة إلى تسجيل الدخول",
sentTitle: "تحقق من بريدك",
sentBody: "إذا كان لـ {{email}} حساب، فقد أرسلنا رابط إعادة التعيين. افتحه واختر كلمة مرور جديدة.",
errorEmailRequired: "يرجى إدخال بريدك الإلكتروني.",
errorSendFailed: "لم يُرسَل الرابط. انتظر دقيقة، ثم حاول مرة أخرى.",
},
reset: {
  subtitleDoneApp: "تم تغيير كلمة المرور. اضغط تسجيل الدخول واستخدمها.",
  sendNewLink: "إرسال رابط جديد",
  titleExpired: "انتهت صلاحية هذا الرابط",
title: "تعيين كلمة مرور جديدة",
titleDone: "تم تحديث كلمة المرور",
subtitle: "اختر كلمة مرور جديدة لحسابك.",
subtitleNoSession: "روابط إعادة التعيين تعمل مرة واحدة وتنتهي صلاحيتها بعد ساعة. اضغط إرسال رابط جديد وسنرسل إليك رابطًا آخر.",
subtitleForm: "اكتب كلمة المرور الجديدة مرتين، ثم اضغط تحديث كلمة المرور.",
subtitleDone: "تم تغيير كلمة المرور. ارجع إلى تطبيق AssetWRX وسجّل الدخول بها.",
newPassword: "كلمة المرور الجديدة",
confirmNewPassword: "تأكيد كلمة المرور الجديدة",
confirmPassword: "تأكيد كلمة المرور",
passwordPlaceholder: "اختر كلمة مرور قوية",
confirmPlaceholder: "أعد إدخال كلمة المرور",
submit: "تحديث كلمة المرور",
updating: "جارٍ التحديث...",
loading: "جارٍ التحميل...",
success: "تم تحديث كلمة المرور. يمكنك تسجيل الدخول.",
goToSignIn: "تسجيل الدخول",
backToSignIn: "العودة إلى تسجيل الدخول",
errorTooShort: "كلمة المرور الجديدة قصيرة جدًا. استخدم {{n}} أحرف على الأقل.",
errorPasswordRequired: "يرجى إدخال كلمة مرور جديدة.",
errorMismatch: "كلمتا المرور غير متطابقتين.",
errorUpdateFailed: "تعذّر تحديث كلمة المرور.",
errorResetFailed: "فشل إعادة تعيين كلمة المرور.",
errorInvalidSession: "هذا الرابط غير صالح أو منتهٍ. اطلب رابطًا جديدًا من صفحة تسجيل الدخول.",
},
reconsent: {
  firstBody: "اقرأ شروط الخدمة وسياسة الخصوصية، وحدّد المربعين، ثم اضغط قبول ومتابعة.",
  firstTitle: "اقبل الشروط للمتابعة",
errorMustAcceptBoth: "يجب قبول كلا الوثيقتين للمتابعة.",
errorMustAcceptOne: "يجب قبول المستند للمتابعة.",
errorSessionExpired: "لقد انتهت صلاحية جلستك. الرجاء اختيار \"الرفض وتسجيل الخروج\"، ثم قم بتسجيل الدخول مرة أخرى للمتابعة.",
errorCouldNotRecord: "تعذر تسجيل قبولك. تحقق من اتصالك وحاول مرة أخرى.",
unavailableTitle: "تعذر التحقق من قبولك المحفوظ",
unavailableBody: "قم بالاتصال وحاول مرة أخرى للتحقق مما إذا كانت هناك أي مستندات تحتاج إلى مراجعتك. يبقى عملك المحفوظ على هذا الجهاز.",
tryAgain: "إعادة المحاولة",
continueOffline: "استمر في وضع عدم الاتصال في الوقت الحالي",
signOut: "تسجيل الخروج",
needsConsentTitle: "تتطلب الشروط المحدثة موافقتك",
needsConsentBody: "لقد قمنا بتحديث المستندات أدناه. يرجى مراجعة كليهما وقبولهما لمواصلة استخدام AssetWRX. إذا اخترت عدم القبول، فسيتم تسجيل خروجك — ولا يزال بإمكانك طلب حذف الحساب أو تصدير بياناتك لاحقًا.",
needsConsentBodyOne: "لقد قمنا بتحديث المستند أدناه. يرجى مراجعته وقبوله لمواصلة استخدام AssetWRX. إذا اخترت عدم القبول، فسيتم تسجيل خروجك — ولا يزال بإمكانك طلب حذف الحساب أو تصدير بياناتك لاحقًا.",
acceptTermsA11y: "أوافق على شروط الخدمة (v{{version}})",
acceptTermsLabel: "أوافق على شروط الخدمة (v{{version}}).",
readTermsA11y: "اقرأ شروط الخدمة",
readTerms: "اقرأ شروط الخدمة",
acceptPrivacyA11y: "أوافق على سياسة الخصوصية (v{{version}})",
acceptPrivacyLabel: "أوافق على سياسة الخصوصية (v{{version}}).",
readPrivacyA11y: "قراءة سياسة الخصوصية",
readPrivacy: "قراءة سياسة الخصوصية",
recording: "جارٍ التسجيل",
recordingEllipsis: "جارٍ التسجيل…",
acceptAndContinue: "قبول ومتابعة",
declineAndSignOut: "الرفض وتسجيل الخروج",
},
guidedHub: {
  groupRule: {
    title: "افحص مجموعة كاملة من الأصول بجدول واحد",
    subtitle: "أعدّ قاعدة مجموعة، مثل كل باب حريق كل شهر.",
  },
  assistantActivity: {
    title: "اختر من يغيّر عبر المساعد",
    subtitle: "فعّل أو أوقف التغييرات عبر المساعد للأعضاء.",
  },
  requestFeature: {
    title: "طلب ميزة",
    subtitle: "أخبر فريق AssetWRX بما يجب أن يفعله التطبيق لاحقًا.",
  },
  assetToursHint: "توجد جولات أخرى في كل أصل: افتحه واضغط + ثم أرشدني.",
  guide: {
    subtitle: "مساعدة خطوة بخطوة لكل جزء من التطبيق.",
    title: "اقرأ دليل الاستخدام",
  },
  invite: {
    subtitle: "يصلهم بريد إلكتروني وينضمون إلى فريقك.",
    title: "ادعُ زميلًا",
  },
title: "ماذا تريد أن تفعل؟",
subtitle: "اختر مهمة. سنبرز لك ما تضغط عليه خطوة بخطوة.",
close: "إغلاق",
groups: {
setup: "إعداد مساحة العمل",
reactive: "المشاركة",
proactive: "تخطيط العمل",
workspace: "إدارة مساحة العمل",
},
building: {
title: "إعداد مبنى",
subtitle: "مبنى، ثم طوابقه وغرفه بداخله.",
},
asset: {
title: "أضف أصلًا",
subtitle: "مبنى أو مركبة أو آلة أو أي شيء تتولى رعايته.",
},
site: {
title: "إضافة موقع",
subtitle: "مكان مثل مبنى أو مستودع يضم الأصول.",
},
contractor: {
title: "إضافة مقاول",
subtitle: "شخص أو شركة ترسل إليها الأعمال.",
},
team: {
title: "إنشاء فريق",
subtitle: "شارك الأصول والعمل مع زملائك.",
},
requesters: {
title: "مشاركة أحد الأصول",
subtitle: "اسمح لشخص برؤية أصل أو طلب عمل عليه.",
},
inspection: {
title: "جدولة تفتيش",
subtitle: "زيارة واحدة أو زيارة تتكرر.",
},
job: {
title: "أنشئ عملًا",
subtitle: "إصلاح أو مهمة ومن يقوم بها.",
},
maintenancePlan: {
title: "قم بإعداد خطة الصيانة",
subtitle: "عمل يتكرر، مثل صيانة سنوية.",
},
compliance: {
title: "راجع الشهادات والامتثال",
subtitle: "اعرف ما ينقص أو ما يحين موعده، وأصلحه.",
},
industryPack: {
title: "أضف قوائم تحقق جاهزة",
subtitle: "قوائم تحقق مصممة لمجالك.",
},
transferOwnership: {
title: "تسليم الفريق إلى مالك جديد",
subtitle: "لا يتغير شيء قبل أن يقبل العرض.",
},
},
guidedJourney: {
  esg: {
    figures: {
      title: "الأرقام الرئيسية",
      body: "كل رقم لآخر 12 شهرًا مع تغيّره عن العام السابق، من قراءات العدّادات التي تسجّلها بالفعل. وتحته الرسم ومن أين يأتي الكربون.",
    },
    refrigerant: {
      title: "غاز التبريد والغازات المفلورة",
      body: "يأتي الغاز من تفاصيل الأصل. سجّل الشحنة، فيحسب التطبيق أطنان CO2e وعدد مرات فحص التسرّب ويخطّط الفحص. يسرد سجل التسرّب كل فحص وتسرّب وإعادة تعبئة.",
    },
    certificates: {
      title: "شهادات الطاقة",
      body: "تُحفظ الشهادات مرة واحدة ضمن المستندات. أضف شهادة EPC أو DEC هناك فيقرأ الذكاء الاصطناعي التصنيف والتواريخ، وتعرضها هذه البطاقة مع فتح الشهادة وتعديل.",
    },
    writeup: {
      title: "اكتبه",
      body: "اختر القارئ وسيكتب الذكاء الاصطناعي ملخصًا قصيرًا يستخدم هذه الأرقام فقط، مع أزرار لإنشاء العمل الذي يقترحه.",
      },
    },
  subJobs: {
    card: {
      title: "أجزاء هذا العمل",
      body: "لكل عمل فرعي شخص أو مقاول وتاريخ وفحوصات وصور خاصة به. تتحقق من كل واحد؛ ويُعتمد العمل كله مرة واحدة.",
    },
    add: {
      title: "اضغط إضافة عمل فرعي",
      body: "في المرة الأولى، حدّد من يدير العمل. ثم أعطِ الجزء عنوانًا ومن ينفذه ومتى. أضف عدة أجزاء متتالية عبر إضافة والتالي.",
    },
  },
  visits: {
    add: {
      title: "تخطيط زيارة أخرى",
      body: "اختر اليوم والوقت. يظهر العمل في العمل والتقويم في كل يوم زيارة، ويُكمل مرة واحدة في النهاية.",
    },
  },
  groupRule: {
    add: {
      title: "اضغط إضافة قاعدة مجموعة",
      body: "تضع قاعدة المجموعة قائمة تحقق واحدة على كل أصل في مجموعة، بجدول واحد.",
    },
    which: {
      title: "حدّد الأصول",
      body: "اختر فئة: مكان أو معدات أو مركبة أو أخرى. ثم ضيّقها إلى نوع مكان أو أحد أنواع الأصول لديك، مثل باب حريق.",
    },
    where: {
      title: "حدّد المكان",
      body: "اتركها في أي مكان، أو اختر مكانًا مثل المبنى A لتأخذ ما بداخله فقط. والمنطقة تضيّقها أكثر.",
    },
    checklist: {
      title: "اختر قائمة التحقق",
      body: "كل فحص تنشئه القاعدة يستخدم قائمة التحقق هذه.",
    },
    howOften: {
      title: "كم مرة ومن متى",
      body: "اختر كم مرة، وتاريخ أول فحص. ويُخطَّط الفحص التالي لكل أصل عند إنجاز الحالي.",
    },
    summary: {
      title: "راجع الجملة",
      body: "تُلخَّص القاعدة في جملة واحدة، مع عدد الفحوصات التي ينشئها الحفظ.",
    },
    save: {
      title: "احفظ القاعدة",
      body: "اضغط حفظ القاعدة. تظهر الفحوصات في صفحة العمل، والأصول التي تنضم إلى المجموعة لاحقًا تحصل على فحوصاتها.",
    },
  },
  assistantActivity: {
    policy: {
      title: "اختر من يمكنه إجراء التغييرات",
      body: "يختار المالكون والمسؤولون: الجميع، أو المسؤولون فقط، أو لا أحد. مع لا أحد، يجيب المساعد وينصح لكنه لا يغيّر شيئًا.",
    },
    briefing: {
      title: "ملخصك الأسبوعي",
      body: "شغّل الملخص الأسبوعي أعلى المساعد أو أوقفه، وأعد تشغيل الأسئلة المقترحة. هذا إعدادك الخاص.",
    },
    memory: {
      title: "ما يتذكره المساعد",
      body: "تفضيلات لمساحة العمل كلها يتبعها المساعد، مثل الأسماء التي تستخدمونها أو من يتولى عادة نوعًا من الأعمال. أضفها أو غيّرها أو انسها هنا.",
    },
    list: {
      title: "كل تغيير مدرج هنا",
      body: "ما الذي تغيّر ومن غيّره ومتى، وهل تم التراجع عنه. يرى الأعضاء تغييراتهم فقط.",
    },
  },
  requestFeature: {
    open: {
      title: "اضغط طلب ميزة",
      body: "تجده في المساعدة، أسفل دليل المستخدم.",
    },
    what: {
      title: "قل ما تريده",
      body: "عنوان قصير، ثم كيف سيساعدك. لا تذكر بيانات شخصية أو بيانات العملاء.",
    },
    area: {
      title: "اختر جزء التطبيق",
      body: "اختر ما يتعلق به وحدد مدى أهميته، وأضف لقطات شاشة إذا كانت مفيدة.",
    },
    send: {
      title: "أرسله",
      body: "اضغط إرسال الطلب. يصل إلى فريق AssetWRX، وتعرض طلباتك حالته وأي رد.",
    },
  },
  inMoreMenu: "اضغط المزيد للعثور عليه.",
  myDay: {
    startNext: {
      body: "اضغط «ابدأ التالي» لفتح العمل التالي والبدء به.",
      title: "ابدأ زيارتك التالية",
    },
    share: {
      body: "اضغط «مشاركة الموقع» ليعرف المخطِّط إن تأخرت. أو اضغط التالي.",
      title: "شارك موقعك (اختياري)",
    },
    agenda: {
      body: "زياراتك اليوم بالترتيب مع المسافة بينها. اضغط التالي.",
      title: "هذا يومك",
    },
  },
  inPlusMenu: "اضغط + للعثور عليه.",
next: "التالي",
skipStep: "تخطَّ هذه الخطوة",
skip: "إنهاء الجولة",
share: {
  confirm: {
    body: "اختر «يمكنه العرض» أو «يمكنه طلب عمل»، ثم اضغط مشاركة. من ليس لديه حساب تصله دعوة بالبريد.",
    title: "اختر ما يمكنهم فعله",
  },
assetOpen: {
title: "افتح الأصل",
body: "اضغط على الأصل الذي تريد مشاركته.",
},
shareAction: {
title: "شارك مع شخص",
body: "اضغط «مشاركة مع شخص أو فريق». سيصلون إلى هذا الأصل فقط.",
},
createContact: {
title: "اختر الشخص",
body: "اضغط على جهة اتصال، أو «إنشاء جهة اتصال وربطها» لإضافة شخص جديد. ثم اضغط متابعة.",
},
},
inspection: {
pickAsset: {
title: "اختر الأصل",
body: "اضغط على الأصل الذي تريد فحصه.",
},
createChecklist: {
title: "اختر قائمة التحقق",
body: "أبقِ هذه القائمة واضغط التالي، أو اضغط تغيير واختر غيرها. لا توجد قائمة؟ اضغط «إنشاء قائمة تحقق».",
},
when: {
title: "اختر الموعد",
body: "اضغط الآن للبدء فورًا، أو لاحقًا لاختيار التاريخ والوقت.",
},
submit: {
title: "ابدأ",
body: "اضغط «بدء الفحص» (أو «جدولة» إن اخترت لاحقًا). أجب عن كل بند ثم اضغط «إكمال الفحص».",
},
},
job: {
pickAsset: {
title: "اختر الأصل",
body: "اضغط على الأصل الذي يخصه العمل.",
},
title: {
title: "اكتب ما يجب فعله",
body: "اكتب عنوانًا قصيرًا، مثل استبدال السير، ثم اختر من سينفذه.",
},
submit: {
title: "أنشئ العمل",
body: "اضغط «إنشاء عمل» (أو «جدولة» إن اخترت لاحقًا). يُبلَّغ من أسندته إليه ويُطلب منه القبول.",
},
},
proactive: {
when: {
title: "اضغط لاحقًا",
body: "ثم اختر يوم ووقت أول فحص.",
},
recurrence: {
title: "اختر عدد المرات",
body: "تحت «تكرار»، اضغط عدد مرات العودة، مثل كل شهر.",
},
submit: {
title: "جدوِله",
body: "اضغط «جدولة الفحص». يظهر كل فحص في العمل في يومه؛ اضغط فتح في الرسالة لرؤيته.",
},
},
addSite: {
name: {
title: "سمِّ الموقع",
body: "اكتب الاسم الذي يستخدمه فريقك، مثل المستودع الشمالي.",
},
location: {
title: "العنوان (اختياري)",
body: "اكتب العنوان واختره من القائمة. أو اضغط التالي للتخطي.",
},
classify: {
title: "نوع الموقع (اختياري)",
body: "اختر نوع المكان وحالته. أو اضغط التالي للتخطي.",
},
structure: {
title: "الموقع الأساسي والفريق (اختياري)",
body: "ضعه داخل موقع أكبر، أو اختر الفريق المسؤول عنه. أو اضغط التالي.",
},
create: {
title: "أنشئ الموقع",
body: "اضغط «إنشاء موقع». سيفتح الموقع جاهزًا لأصوله.",
},
},
addAssetsToSite: {
assign: {
title: "أضف أصولًا إلى هذا الموقع",
body: "اضغط «عيّن أصلًا» واختر الأصل لنقله إلى هنا. ستؤكد رسالة النقل.",
},
},
addContractor: {
name: {
title: "اكتب الاسم",
body: "أدخل اسم الشخص أو الشركة.",
},
contact: {
title: "اكتب بريدهم",
body: "يحتاج المقاول إلى بريد: تصله عليه دعوات الأعمال والعروض.",
},
save: {
title: "أضفهم",
body: "اضغط «إضافة جهة اتصال». لإسناد عمل لهم افتح عملًا واضغط إسناد.",
},
},
raiseRequest: {
  summary: {
    body: "اكتب ملخصًا قصيرًا، مثل صنبور يسرّب في المطبخ.",
    title: "اكتب ما المشكلة",
  },
outcome: {
title: "ماذا تحتاج؟",
body: "اختر: مساعدة فقط، أو إنجاز عمل، أو فحص.",
},
submit: {
title: "أرسله",
body: "اضغط إرسال. يُفتح العمل أو الفحص مُعبأً مباشرة، وإلا ينتظر في العمل.",
},
},
shareReport: {
contact: {
title: "اختر المستلم",
body: "اضغط «اختيار جهة اتصال» واختر الشخص.",
},
role: {
title: "تحقق من صفته",
body: "صفته مأخوذة من جهة الاتصال. اضغط تغيير فقط إن كانت خاطئة، أو اضغط التالي.",
},
send: {
title: "أرسله",
body: "اضغط «إرسال التقرير». يصلهم بريد برابط، وتُبلَّغ عند ردهم.",
},
},
planADay: {
  apply: {
    body: "لا يُحفظ شيء حتى تضغط تطبيق. بعدها يُطلب من كل شخص قبول يومه.",
    title: "اضغط تطبيق للحفظ",
  },
  optimise: {
    body: "اضغط «اقتراح خطة» لملء اليوم بأقل تنقل. اضغط × على أي تغيير لا تريده.",
    title: "أو دع التطبيق يقترح",
  },
  panel: {
    body: "اختر الشخص واليوم ووقت البدء. يظهر متقطعًا حتى تضغط تطبيق.",
    title: "اختر من ومتى",
  },
  unplanned: {
    body: "تعرض هذه القائمة الأعمال بلا وقت أو بلا شخص. اضغط على أحدها لتخطيطه.",
    title: "ابدأ بغير المخطط",
  },
  },
convertRequest: {
approve: {
title: "وافق على الطلب",
body: "اضغط موافقة ثم موافقة مرة أخرى للتأكيد. يُبلَّغ صاحب الطلب.",
},
convert: {
title: "حوّله إلى عمل",
body: "اضغط «إنشاء عمل» أو «فحص». التفاصيل مُعبأة؛ تختار أنت من ومتى.",
},
},
addDocument: {
  title: {
    body: "اكتب اسمًا واضحًا، مثل شهادة سلامة الغاز 2026.",
    title: "أعطه عنوانًا",
  },
type: {
title: "اختر نوع المستند",
body: "تحت «نوع المستند»، اختر شهادة أو ضمان أو امتثال أو عام.",
},
save: {
title: "أضف الملف واحفظ",
body: "أرفق الملف، وأضف تاريخ الانتهاء إن وُجد، ثم اضغط «حفظ المستند».",
},
},
assignAssetTeam: {
change: {
title: "اضغط تغيير",
body: "بجانب «الفريق المسؤول»، اضغط تغيير.",
},
pick: {
title: "اختر الفريق",
body: "اضغط على الفريق. ستؤكد رسالة من يمكنه رؤيته الآن.",
},
},
addTeam: {
open: {
title: "اضغط «إنشاء فريق»",
body: "يشارك الفريق الأصول والعمل مع من تدعوهم. لديك فريق؟ اضغط فريق جديد.",
},
name: {
title: "سمِّ الفريق",
body: "استخدم اسمًا يعرفه زملاؤك.",
},
submit: {
title: "أنشئه",
body: "اضغط «إنشاء فريق». سيفتح مربع الدعوة بعدها لإضافة الأشخاص.",
},
},
inviteMembers: {
open: {
title: "اضغط «دعوة أشخاص»",
body: "ادعُ زميلًا إلى هذا الفريق.",
},
email: {
title: "أدخل بريده",
body: "اكتب البريد الإلكتروني، واحدًا في كل سطر، واختر عضو أو مسؤول.",
},
send: {
title: "أرسل الدعوة",
body: "اضغط «إرسال الدعوة». تصلهم رسالة ويظهرون تحت الأعضاء بعد القبول.",
},
},
assignContractor: {
open: {
title: "اضغط إسناد",
body: "اختر الزميل أو المقاول. يحتاج المقاول إلى بريد ليصله الإشعار.",
},
},
aiReport: {
reader: {
title: "لمن هذا التقرير؟",
body: "اختر القارئ. تُعرض الحقائق نفسها بالترتيب الذي يهم هذا القارئ. أو اضغط التالي.",
},
analyses: {
title: "اختر ما يشمله",
body: "كل المواضيع مفعّلة. اضغط على أحدها لاستبعاده، أو اضغط التالي.",
},
generate: {
title: "أنشئ التقرير",
body: "راجع التكلفة، ثم اضغط «كتابة نسخة الذكاء الاصطناعي». ستُبلَّغ عندما يصبح جاهزًا، ولا يُستهلك الرصيد إلا حينها.",
},
},
relateAsset: {
search: {
title: "ابحث عن الأصل الآخر",
body: "ابحث عن الأصل الآخر واضغط عليه.",
},
save: {
title: "احفظ الربط",
body: "اختر نوع العلاقة واضغط «إضافة علاقة».",
},
},
publicIntake: {
share: {
title: "اضغط مشاركة",
body: "يتم إعداد الإبلاغ برمز QR من المشاركة.",
},
choose: {
title: "اسمح لأي شخص بالإبلاغ",
body: "اضغط «اسمح لأي شخص لديه الرمز بالإبلاغ عن مشكلة». لا حاجة إلى حساب.",
},
enable: {
title: "فعّله",
body: "فعّل المفتاح. يظهر الرمز والرابط أسفله.",
},
copy: {
title: "شارك الرابط",
body: "اضغط «نسخ الرابط» (أو «طباعة QR» على الحاسوب) وضعه في مكان ظاهر.",
},
},
setUpBuilding: {
name: {
title: "سمِّ المبنى",
body: "اكتب الاسم الذي يستخدمه الناس، مثل المبنى A أو البرج الشمالي.",
},
type: {
title: "إنه مكان",
body: "تم اختيار مكان مسبقًا. الطوابق والغرف ومواقف السيارات والمناطق الأخرى أماكن أيضًا.",
},
placeType: {
title: "اضغط مبنى",
body: "حدد نوع المكان. اختر مبنى هنا؛ لاحقًا تختار طابق أو غرفة لما بداخله.",
},
save: {
title: "أنشئه",
body: "اضغط إنشاء أصل. يُفتح المبنى بعد ذلك.",
},
addInside: {
title: "أضف طوابقه",
body: "اضغط إضافة مكان بداخله لإضافة الطابق 1. لكل طابق الزر نفسه لغرفه، وزر إضافة معدّات هنا لما هو مركّب فيه.",
},
},
addAsset: {
name: {
title: "سمِّه",
body: "اكتب الاسم الذي يستخدمه فريقك، مثل الغلاية 3 أو شارع البلوط 14.",
},
type: {
title: "اختر النوع",
body: "اضغط مكان أو معدّات أو مركبة أو أخرى. المكان هو مبنى أو طابق أو غرفة أو أي منطقة أخرى. إذا ظهرت بطاقة \"يبدو مثل\"، اضغط استخدام هذا.",
},
location: {
title: "أين هو؟ (اختياري)",
body: "أضف الموقع أو العنوان ليسهل العثور عليه. أو اضغط التالي للتخطي.",
},
identify: {
title: "صورة ورقم تسلسلي (اختياري)",
body: "أضف صورة والرقم المكتوب على لوحته ليسهل العثور عليه. أو اضغط التالي.",
},
details: {
title: "تفاصيل إضافية (اختياري)",
body: "أضف الشركة المصنّعة والطراز والتواريخ المهمة الآن أو لاحقًا. أو اضغط التالي.",
},
save: {
title: "أنشئه",
body: "اضغط «إنشاء أصل». سيفتح بعدها جاهزًا للفحص.",
},
},
decommission: {
options: {
title: "افتح القائمة ⋯",
body: "اضغط ⋯ أعلى صفحة الأصل.",
},
status: {
  title: "اضغط على تغيير الحالة",
  body: "التشغيل والإخراج من الخدمة والإخراج النهائي والاستعادة كلها هنا.",
},
choose: {
title: "اضغط إيقاف التشغيل",
body: "يحتفظ الأصل بسجله. يتوقف العمل الدوري حتى يعود إلى الخدمة.",
},
reason: {
title: "اختر السبب",
body: "اختر سبب خروجه من الخدمة. سيُحفظ في السجل.",
},
confirm: {
title: "أكّد",
body: "اضغط «إنشاء عمل التأمين»، أو أوقفه واضغط «إخراج من الخدمة الآن».",
},
},
commission: {
start: {
title: "اضغط تشغيل",
body: "من الشريط، اضغط تشغيل لإدخال الأصل إلى الخدمة.",
},
inspect: {
title: "ابدأ الفحص",
body: "اضغط «بدء الفحص». بعد انتهائه وانتهاء أعماله، اضغط «إعادة إلى الخدمة».",
},
},
retire: {
options: {
title: "افتح القائمة ⋯",
body: "اضغط ⋯ أعلى صفحة الأصل.",
},
status: {
  title: "اضغط على تغيير الحالة",
  body: "التشغيل والإخراج من الخدمة والإخراج النهائي والاستعادة كلها هنا.",
},
choose: {
title: "اضغط «إخراج الأصل من الخدمة نهائيًا»",
body: "لا يمكن إخراج الأصل من الخدمة نهائيًا إلا إذا كان خارج الخدمة. وإلا يُعرض عليك «إخراج من الخدمة» أولًا.",
},
reason: {
title: "اذكر السبب",
body: "اختر السبب. إذا بيع أو أُتلف، اذكر من استلمه.",
},
confirm: {
title: "اكتب «إنهاء» للتأكيد",
body: "اكتب «إنهاء» ثم اضغط «إخراج هذا الأصل من الخدمة نهائيًا». يمكن للمالك أو المسؤول استعادته لاحقًا.",
},
},
meterReading: {
value: {
title: "أدخل القراءة",
body: "اكتب الرقم على العداد. على الهاتف يمكنك إضافة صورة بدلًا من ذلك ليقرأها التطبيق.",
},
save: {
title: "احفظها",
body: "اضغط «حفظ القراءة». الخطط حسب المسافة أو الساعات تبدأ من هذا الرقم.",
},
},
maintenancePlan: {
  asset: {
    body: "اضغط الأصل واختر ما تخصه هذه الخطة. محدد بالفعل؟ اضغط التالي.",
    title: "اختر الأصل",
  },
title: {
title: "اكتب ما يُنجز",
body: "تحت «ما يُنجز»، اكتب العمل في كل مرة، مثل الصيانة السنوية.",
},
cadence: {
title: "اختر عدد المرات",
body: "تحت «متى يحين موعده؟» أبقِ «يتكرر» واختر كل 12 شهرًا، أو فعّل التكرار حسب العداد. ثم اضغط التالي.",
},
save: {
title: "أنشئ الخطة",
body: "اختر عمل أو فحص تحت «نفّذه كـ»، ثم اضغط «إنشاء خطة». ستخبرك رسالة متى يظهر أولها في العمل.",
},
},
addKnowledge: {
kind: {
title: "اختر ما تضيفه",
body: "اختر ملاحظة أو سؤالًا شائعًا أو طريقة أو رابطًا أو ملفًا.",
},
title: {
title: "أعطه عنوانًا",
body: "استخدم كلمات يبحث عنها الناس، مثل إعادة ضبط الغلاية. ثم اكتب أو أملِ النص.",
},
save: {
title: "احفظه",
body: "اضغط حفظ. سيجده كل من يعمل على هذا الأصل.",
},
},
moveAsset: {
reason: {
title: "نُقل أم تصحيح؟",
body: "اضغط «تم نقله» أو «كان خطأ».",
},
location: {
title: "أين هو الآن؟",
body: "ابحث عن العنوان، أو استخدم موقعك الحالي.",
},
submit: {
title: "احفظ النقل",
body: "اضغط «تسجيل النقل» أو «تصحيح الموقع». يبقى المكان القديم في السجل.",
},
},
complianceRegister: {
refine: {
title: "ابحث عمّا تحتاجه (اختياري)",
body: "ابحث بالاسم، أو اضغط تصفية. ثم اضغط التالي.",
},
row: {
title: "عالج سطرًا",
body: "كل سطر يوضح ما ينقص أو ما يحين موعده. اضغط زره، مثل تجديد.",
},
},
industryPack: {
install: {
title: "ثبّت حزمة",
body: "اضغط «تثبيت الحزمة» على حزمة مجالك. ستظهر قوائمها في قوائم التحقق.",
},
},
transferOwnership: {
open: {
title: "اضغط «نقل الملكية»",
body: "تجده في إعدادات الفريق. يراه المالك فقط عند وجود عضو آخر.",
},
member: {
title: "اختر المالك الجديد",
body: "اختر عضوًا. لا يتغير شيء حتى يقبل، ثم تصبح مسؤولًا.",
},
},
},
mfa: {
  codeNotValid: "لم ينجح هذا الرمز. تتغير الرموز كل 30 ثانية، لذا افتح تطبيق المصادقة واكتب أحدث رمز.",
invalidCode: "هذا الرمز غير صالح. تحقق من تطبيق المصادقة وحاول مرة أخرى.",
enterCode: "أدخل الرمز المكوّن من 6 أرقام",
verifying: "جارٍ التحقق…",
verifyCta: "تحقق وفعّل",
challenge: {
  contactSupport: "تواصل مع دعم AssetWRX",
pageTitle: "التحقق بخطوتين",
title: "أدخل رمز التحقق",
body: "افتح تطبيق المصادقة وأدخل الرمز المكوّن من 6 أرقام الخاص بـ AssetWRX.",
backA11y: "إلغاء تسجيل الدخول والرجوع",
back: "رجوع",
loadError: "تعذّر تحميل طريقة التحقق بخطوتين. سجّل الدخول مرة أخرى.",
resetSent_one: "أبلغنا مسؤول مساحة العمل. يمكنه إعادة تعيين التحقق بخطوتين لتتمكن من إعداده مجددًا.",
resetSent_other: "أبلغنا مسؤولي مساحة العمل. يمكنهم إعادة تعيين التحقق بخطوتين لتتمكن من إعداده مجددًا.",
resetNoAdmin: "أنت مالك مساحة العمل، لذا لا يوجد من يعلوك لإعادة تعيين ذلك. سجّل الدخول على جهاز لا يزال يحتوي على تطبيق المصادقة، أو تواصل مع دعم AssetWRX أدناه.",
resetError: "تعذّر إرسال الطلب. يرجى المحاولة مرة أخرى.",
verifyCta: "تحقق",
lostDevice: "فقدت جهازك؟ اطلب من مسؤول مساحة العمل إعادة تعيين التحقق بخطوتين، أو سجّل الخروج.",
requestReset: "طلب إعادة تعيين من المسؤول",
requesting: "جارٍ الإرسال…",
signOut: "تسجيل الخروج",
resetSent_zero: "لم يُبلَّغ أي مسؤول لمساحة العمل.",
resetSent_two: "أبلغنا مسؤولَي مساحة العمل. يمكنهما إعادة تعيين التحقق بخطوتين لتتمكن من إعداده مجددًا.",
resetSent_few: "أبلغنا مسؤولي مساحة العمل. يمكنهم إعادة تعيين التحقق بخطوتين لتتمكن من إعداده مجددًا.",
resetSent_many: "أبلغنا مسؤولي مساحة العمل. يمكنهم إعادة تعيين التحقق بخطوتين لتتمكن من إعداده مجددًا.",
},
enroll: {
  otherPhoneQr: "تستخدم هاتفًا آخر؟ امسح هذا الرمز.",
  step2SameDevice: "اضغط افتح تطبيق المصادقة، وأضف الحساب، ثم عُد إلى هنا",
  a11yGooglePlay: "{{app}}: التنزيل من Google Play",
  a11yAppStore: "{{app}}: التنزيل من App Store",
  appBlurb: "مجاني. يعمل على iPhone وAndroid.",
backA11y: "رجوع",
back: "رجوع",
title: "إعداد تسجيل الدخول بخطوتين",
lead: "يضيف هذا خطوة ثانية عند تسجيل الدخول حتى لا يدخل أحد سواك — حتى لو عرف شخص كلمة مرورك. يستغرق الأمر نحو دقيقة.",
startError: "تعذّر بدء الإعداد. يرجى المحاولة مرة أخرى.",
step1: "احصل على تطبيق مصادقة مجاني على هاتفك",
step1Hint: "لديك واحد بالفعل؟ انتقل إلى الخطوة 2.",
appStore: "iPhone",
googlePlay: "Android",
step2: "في التطبيق، اضغط على \"＋\" وامسح هذا الرمز",
qrAlt: "رمز QR للتحقق بخطوتين",
manualLabel: "تعذّر المسح؟ أدخل هذا المفتاح يدويًا:",
copySecret: "نسخ مفتاح الإعداد",
openApp: "افتح تطبيق المصادقة",
step3: "أدخل الرمز المكوّن من 6 أرقام الذي يعرضه التطبيق",
preparing: "جارٍ تجهيز الإعداد…",
backupTitle: "أضف نسخة احتياطية تحسبًا",
backupBody: "التحقق بخطوتين مفعّل. إذا فقدت تطبيق المصادقة يومًا، فإن تطبيقًا ثانيًا على جهاز آخر هو أسرع طريقة للعودة. موصى به.",
addBackup: "إضافة أداة مصادقة احتياطية",
finish: "إنهاء",
backupSetupTitle: "أضف تطبيق المصادقة الاحتياطي",
backupSetupBody: "امسح هذا بتطبيق المصادقة الثاني، ثم أدخل الرمز المكوّن من 6 أرقام الذي يعرضه.",
skipBackup: "تخطَّ الآن",
},
gate: {
challengeTitle: "تأكيد هويتك",
blockedTitle: "تسجيل الدخول بخطوتين مطلوب",
nagTitle: "فعّل تسجيل الدخول بخطوتين",
challengeBody: "أدخل رمز تطبيق المصادقة للمتابعة.",
blockedBody: "للحفاظ على أمان حسابك، أعدّ تطبيق مصادقة للمتابعة.",
nagBody: "أضف تطبيق مصادقة لتعزيز الأمان بشكل كبير — لا يستغرق سوى دقيقة.",
nagBodyDated: "سيصبح تسجيل الدخول بخطوتين مطلوبًا في {{dateLabel}}. أعدّه الآن — لا يستغرق سوى دقيقة.",
verifyCta: "أدخل الرمز",
setupCta: "إعداد التحقق بخطوتين",
signOut: "تسجيل الخروج",
later: "ذكّرني لاحقًا",
},
},
};
